import { Accordion } from "../../../../accordion";
import { DetailsFieldTitle } from "../../..";

import "./array-details-field.scss";
import { IProps } from "./array-details-field.types";
import ArrayDetailsSection from "./array-details-section";

/**
 * Display a details row containing a collapsible field.
 * @param props.field Array field.
 * @returns           Table row.
 */
const ArrayDetailsField = ({ field }: IProps) => (
    <tr className="array-details-field">
        <td colSpan={2}>
            <DetailsFieldTitle>{field.title}</DetailsFieldTitle>
            <Accordion>
                {Array.isArray(field.properties.sections) &&
                    field.properties.sections.map((section) => (
                        <ArrayDetailsSection section={section} key={section.title} />
                    ))}
            </Accordion>
        </td>
    </tr>
);

export default ArrayDetailsField;
